import { AxiosStatic } from "axios";
import { LineManager } from "@teamprevent/common/lineManagers/models";

export class LineManagersApi {

    private axios: AxiosStatic;

    constructor(ax: AxiosStatic) {
        this.axios = ax;
    }

    public async getAll(customerId: string, customerRole: string | null): Promise<LineManager[]> {
        const queryString = customerRole ? `?customerRole=${customerRole}` : "";
        const response = await this.axios.get(`/api/customer/${customerId}/linemanagers${queryString}`);
        const model = response.data as LineManager[];
        return model;
    }
}
